import React from 'react';

export const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={className}
      onClick={onClick}
      style={{
        background: `url(${process.env.REACT_APP_ASSETS_BASE_URL}/images/next-arrow.png) no-repeat`,
        backgroundSize: 'contain',
      }}
    />
  );
};

export const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={className}
      onClick={onClick}
      style={{
        background: `url(${process.env.REACT_APP_ASSETS_BASE_URL}/images/prev-arrow.png) no-repeat`,
        backgroundSize: 'contain',
      }}
    />
  );
};
